// extracted by css-extract-rspack-plugin
export default {"bui-Button":"ehvqAPLpGkUDji8W","bui-ButtonContent":"EF4fHunD7scFSiZD","bui-ButtonSpinner":"jJBX1pc9Npcl7VKg","bui-spin":"kAw99xOlWE8d2kuW"};